var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c(
      "div",
      {
        staticClass: "mailbox",
        class: { "is-open": _vm.isLeftSidebarVisible },
      },
      [
        _c("div", { staticClass: "mailbox-sidebar" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-theme btn-sm btn-block",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.getRecords(false)
                },
              },
            },
            [
              _vm._v(
                "Обновить\n        (" +
                  _vm._s(
                    (_vm.showArchive ? _vm.archiveCahts : _vm.chats).length
                  ) +
                  ")\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              class: {
                "btn btn-outline-primary btn-sm btn-block mt-1 mb-1": true,
                active: _vm.showArchive,
              },
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  _vm.showArchive = !_vm.showArchive
                },
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.showArchive ? "Активные чаты" : "Архив") +
                  "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _vm.showArchive
            ? _c(
                "div",
                { staticClass: "mb-1" },
                [
                  _c("DateSelect", {
                    ref: "selectedDate",
                    attrs: {
                      disabled: false,
                      format: "DD.MM.YYYY",
                      disabledBefore: _vm.archiveDateDisabledBefore,
                      onSelect: (date) => _vm.updateSelectedDate(date),
                      selectedDate: _vm.selectedDate,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "ul_block" }, [
            _c(
              "ul",
              { staticClass: "sidebar-menu mt-0" },
              _vm._l(
                _vm.showArchive ? _vm.archiveCahts : _vm.chats,
                function (c, i) {
                  return _c(
                    "li",
                    {
                      class: {
                        "pointer border-bottom": true,
                        active: _vm.selectedChat?.id === c.id,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.openChat(c)
                            },
                          },
                        },
                        [
                          c.bot.type === 2 ? [_vm._m(0, true)] : _vm._e(),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$AllProjects &&
                                  _vm.$AllProjects[c.bot.project_id]?.title
                              ) + " "
                            ),
                            _c(
                              "span",
                              {
                                class: {
                                  badge: true,
                                  "badge-telegram":
                                    c.bot.platform === "telegram",
                                  "badge-whatsapp":
                                    c.bot.platform === "whatsapp",
                                  "badge-jivo": c.bot.platform === "jivo",
                                  "badge-viber": c.bot.platform === "viber",
                                },
                              },
                              [_vm._v(_vm._s(c.bot.platform))]
                            ),
                            _vm._v(" "),
                            c.hasNewMessages
                              ? _c(
                                  "span",
                                  { staticClass: "badge badge-success" },
                                  [_vm._v("new")]
                                )
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  c?.client?.client_data?.name || "Без имени"
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          c.bot.platform === "whatsapp"
                            ? _c("p", { staticClass: "fs-10" }, [
                                _vm._v(_vm._s(c.client.chat_id)),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          c.bot.platform === "telegram"
                            ? _c("p", { staticClass: "fs-10" }, [
                                _vm._v(_vm._s(c.client.client_data?.username)),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "text-muted" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.printDate(c?.last_message?.created_at)
                                ) +
                                  " (" +
                                  _vm._s(c.id) +
                                  ")\n                "
                              ),
                              _vm.showArchive
                                ? _c("StatusChange", {
                                    attrs: { dialog: c, showOnly: true },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      c.client?.phone?.black_list
                        ? _c(
                            "div",
                            { staticClass: "black_list_btn" },
                            [
                              _c("BlackListButton", {
                                attrs: {
                                  phone: c.client.phone,
                                  blackList: c.client.phone.black_list,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  )
                }
              ),
              0
            ),
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "left-sidebar-btn",
              on: {
                click: function ($event) {
                  _vm.isLeftSidebarVisible = !_vm.isLeftSidebarVisible
                },
              },
            },
            [
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isLeftSidebarVisible,
                    expression: "!isLeftSidebarVisible",
                  },
                ],
                staticClass: "icon-fa icon-fa-angle-right",
              }),
              _vm._v(" "),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isLeftSidebarVisible,
                    expression: "isLeftSidebarVisible",
                  },
                ],
                staticClass: "icon-fa icon-fa-angle-left",
              }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mailbox-content" },
          [
            _c("pulse-loader", {
              staticClass: "text-center mt-5",
              attrs: {
                loading: _vm.loading,
                color: _vm.$constants.LOADING_COLOR,
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "wrapCollapse" },
              [
                _c("pulse-loader", {
                  staticClass: "text-center mt-5",
                  attrs: {
                    loading: _vm.messagesLoading,
                    color: _vm.$constants.LOADING_COLOR,
                  },
                }),
                _vm._v(" "),
                !_vm.messagesLoading
                  ? [
                      _vm.chatToDisplay
                        ? [
                            _vm.warningProjects.includes(
                              _vm.selectedChat?.bot?.project_id
                            )
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "alert alert-danger mr-2 mt-2 mb-2 ml-0",
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        "Осторожно, обращение со справочной!!!"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(_vm._s(_vm.warningText)),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "text-right" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-default",
                                          on: {
                                            click: function ($event) {
                                              _vm.message = _vm.warningText
                                            },
                                          },
                                        },
                                        [_vm._v("Добавить в чат")]
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "row m-0" }, [
                              _c("div", { staticClass: "col-md-7 p-1" }, [
                                _c(
                                  "div",
                                  { staticClass: "messages_block mr-2" },
                                  [
                                    _c("ChatMessages", {
                                      attrs: {
                                        loadedImages: _vm.loadedImages,
                                        updateLoadedImages: (i) =>
                                          (_vm.loadedImages = i),
                                        messages: _vm.chatToDisplay.messages,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "mt-1 mb-1 mr-2" }, [
                                  _c(
                                    "form",
                                    {
                                      on: {
                                        submit: function ($event) {
                                          $event.preventDefault()
                                          return (() =>
                                            _vm.sendMessage("message")).apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.message,
                                                expression: "message",
                                              },
                                            ],
                                            staticClass: "form-control br-0",
                                            attrs: {
                                              type: "text",
                                              disabled: _vm.sendLoading,
                                              required: "",
                                              placeholder: "Сообщение",
                                            },
                                            domProps: { value: _vm.message },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.message =
                                                  $event.target.value
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "input-group-append",
                                            },
                                            [
                                              _c("LoadingButton", {
                                                attrs: {
                                                  title: "Отправить",
                                                  type: "submit",
                                                  loading: _vm.sendLoading,
                                                  color:
                                                    _vm.$constants
                                                      .LOADING_COLOR,
                                                  onClick: () => {},
                                                  className:
                                                    "btn btn-outline-info br-0",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-5 p-1 pt-2" }, [
                                _c("div", { staticClass: "card" }, [
                                  _c(
                                    "div",
                                    { staticClass: "card-body p-1" },
                                    [
                                      _c("DrugSearchNew", {
                                        ref: "searchDrug",
                                        attrs: {
                                          onSelect: (d) =>
                                            _vm.searchDataForDrug(d),
                                          showOptions: true,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "mt-1" }, [
                                        _c("label", [
                                          _vm._v("Выберите город доставки"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.selectedCityId,
                                                expression: "selectedCityId",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            on: {
                                              change: function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.selectedCityId = $event
                                                  .target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              { attrs: { value: "0" } },
                                              [_vm._v("Почтовая доставка")]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.sortArray(
                                                _vm.$AllCities,
                                                "name"
                                              ),
                                              function (c) {
                                                return _c(
                                                  "option",
                                                  { domProps: { value: c.id } },
                                                  [_vm._v(_vm._s(c.name))]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm.drugForStoreData
                                        ? _c(
                                            "div",
                                            [
                                              _c("ChatStoreStatus", {
                                                attrs: {
                                                  selectedCityId:
                                                    _vm.selectedCityId,
                                                  projectId:
                                                    _vm.selectedChat.locality
                                                      .project_id,
                                                  drug: _vm.drugForStoreData,
                                                  addDrugToOrder: (drug) =>
                                                    _vm.$refs.newOrderBlock.updateDrugData(
                                                      drug,
                                                      0
                                                    ),
                                                  sendDrugMessage: (drug) =>
                                                    _vm.sendMessage(
                                                      "drug",
                                                      drug
                                                    ),
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "card" }, [
                                  _c(
                                    "div",
                                    { staticClass: "card-body p-1" },
                                    [
                                      _vm.selectedChat
                                        ? _c("DeliveryStatus", {
                                            ref: "deliveryStatus",
                                            attrs: {
                                              selectedChat: _vm.selectedChat,
                                              projectId:
                                                _vm.selectedChat.locality
                                                  .project_id,
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "card" }, [
                                  _c(
                                    "div",
                                    { staticClass: "card-body p-1" },
                                    [
                                      _c("StatusChange", {
                                        attrs: {
                                          dialog: _vm.chatToDisplay,
                                          cityId: _vm.selectedCityId,
                                          drug: _vm.$refs.searchDrug?.drug,
                                          onUpdate: () => _vm.getRecords(false),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "p-1" },
                              [
                                _c("ChatReplySnippets", {
                                  attrs: {
                                    hideManage: true,
                                    onSelect: (m) => (_vm.message = m),
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "new_order_from_bot_block mt-2 mr-2",
                              },
                              [
                                _vm.chatToDisplay?.orders.length
                                  ? _c("div", { staticClass: "card" }, [
                                      _vm._m(1),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "card-body" },
                                        _vm._l(
                                          _vm.getSortedOrders(),
                                          function (o) {
                                            return _c(
                                              "div",
                                              { staticClass: "mb-1" },
                                              [
                                                _vm._v(
                                                  "\n                    (" +
                                                    _vm._s(o.project_label) +
                                                    ") "
                                                ),
                                                _c("strong", [
                                                  _vm._v(_vm._s(o.id)),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.printOrderStatus(o)
                                                    ),
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-xs btn-info ml-1",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openOrderInModal(
                                                          o.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "icon-fa icon-fa-eye",
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-xs btn-outline-success ml-1",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.loadNewOrder(
                                                          o.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "показать заявку тут\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.selectedChat?.order_id
                                  ? [
                                      _c("EditOrder", {
                                        ref: "newOrderBlock",
                                        attrs: {
                                          orderId: _vm.selectedChat.order_id,
                                          sendDrugMessage: (drug) =>
                                            _vm.sendMessage("drug", drug),
                                        },
                                      }),
                                    ]
                                  : [
                                      _c("NewOrder", {
                                        ref: "newOrderBlock",
                                        attrs: {
                                          sendDrugMessage: (drug) =>
                                            _vm.sendMessage("drug", drug),
                                          extraOptions: {
                                            chatBotDialogId:
                                              _vm.selectedChat?.id,
                                            savePreOrder: true,
                                            disable: {
                                              projectSelect: true,
                                            },
                                            hide: {
                                              newOrderHeader: true,
                                            },
                                          },
                                        },
                                      }),
                                    ],
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-3 mr-2 flex justify-content-between",
                              },
                              [
                                _c("LoadingButton", {
                                  attrs: {
                                    title: "Отправить диалог в архив",
                                    type: "button",
                                    loading: _vm.sendLoading,
                                    color: _vm.$constants.WARNING_COLOR,
                                    onClick: () => _vm.closeDialog(),
                                    className: "btn btn-outline-warning br-0",
                                  },
                                }),
                                _vm._v(" "),
                                _c("LoadingButton", {
                                  attrs: {
                                    title: "Отправить заказ в чат",
                                    type: "button",
                                    loading: _vm.sendLoading,
                                    color: _vm.$constants.PRIMARY_COLOR,
                                    onClick: () => _vm.sendMessage("offer"),
                                    className: "btn btn-outline-info br-0 mr-2",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("span", { staticClass: "badge badge-primary" }, [
        _vm._v("Оплата StreamPay/CoinCat"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Заявки клиента")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }